var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitepin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1215_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30234 17.2841C9.06953 15.0613 13 9.67383 13 6.64773C13 2.97624 10.0899 0 6.5 0C2.91146 0 0 2.97624 0 6.64773C0 9.67383 3.96094 15.0613 5.69766 17.2841C6.11406 17.8138 6.88594 17.8138 7.30234 17.2841ZM6.5 8.86364C5.30495 8.86364 4.33333 7.86994 4.33333 6.64773C4.33333 5.42552 5.30495 4.43182 6.5 4.43182C7.69505 4.43182 8.66667 5.42552 8.66667 6.64773C8.66667 7.86994 7.69505 8.86364 6.5 8.86364Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1215_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17.7273,
    fill: "white",
    transform: "matrix(-1 0 0 1 13 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepin);
export default __webpack_public_path__ + "static/media/whitepin.d7f7fe808daa0373b1ff722188a9f037.svg";
export { ForwardRef as ReactComponent };